<template>
  <v-card
    outlined
    class="mb-2 px-4"
    :loading="isLoading"
    :class="{ 'gap-selected': gap.selected, 'cursor-pointer': selectable }"
    @click.native="selectable ? (gap.selected = !gap.selected) : ''"
  >
    <template slot="progress">
      <v-progress-linear indeterminate top absolute />
    </template>
    <v-card-title
      class="font-size-16 font-weight-bold justify-space-between pa-0 pt-3 pb-3"
    >
      <p>
        {{ gapTitle }}
      </p>
      <div v-if="editable && isEditMode">
        <Button
          color="grey"
          icon="mdi-check"
          size="small"
          class="mr-3"
          :loading="isLoading"
          :disabled="!canSave"
          @click="saveGap"
        />
        <Button
          color="grey"
          icon="mdi-close"
          size="small"
          :disabled="isLoading"
          @click="cancelEdition"
        />
      </div>

      <div v-if="editable && !isEditMode && !isLoading">
        <Button
          color="grey"
          icon="mdi-pencil"
          size="small"
          class="mr-3"
          @click="isEditMode = true"
        />
        <Button
          color="grey"
          icon="mdi-delete-outline"
          size="small"
          @click="$emit('remove')"
        />
      </div>
      <v-checkbox
        v-if="selectable"
        v-model="gap.selected"
        class="pa-0 ma-0 ms-3"
        @click.native="selectable ? (gap.selected = !gap.selected) : ''"
      />
    </v-card-title>

    <v-card-text v-if="isEditMode" class="px-0">
      <GapForm :gap="editableGap" :isLoading="isLoading" />
    </v-card-text>

    <v-card-text v-if="!isEditMode && !isLoading" class="px-0">
      <v-row>
        <v-col cols="6" class="d-flex flex-column">
          <span class="grey--text text--darken-2 font-size-12">
            {{ $t('problem_solving.gaps_analysis_tool.reality_label') }}
          </span>

          <span class="black--text mt-1">{{ gap.reality }}</span>
        </v-col>

        <v-col cols="6" class="d-flex flex-column">
          <span class="grey--text text--darken-2 font-size-12">
            {{ $t('problem_solving.gaps_analysis_tool.expectation_label') }}
          </span>

          <span class="black--text mt-1">{{ gap.expectation }}</span>
        </v-col>

        <v-col cols="12" class="d-flex flex-column mt-4">
          <span class="grey--text text--darken-2 font-size-12">
            {{ $t('problem_solving.gaps_analysis_tool.conclusion_label') }}
          </span>

          <span class="black--text mt-1">
            {{ gap.conclusion }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import GapForm from './GapForm'
import Button from '@/components/UI/Button'
export default {
  name: 'GapCard',

  components: {
    GapForm,
    Button,
  },

  props: {
    index: {
      type: Number,
      required: true,
    },

    gap: {
      type: Object,
      required: true,
    },

    editable: {
      type: Boolean,
      default: false,
    },

    selectable: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isEditMode: false,
      editableGap: { ...this.gap },
    }
  },

  computed: {
    gapTitle() {
      return this.$t('problem_solving.gaps_analysis_tool.gap_title', {
        gapNumber: (this.index + 1).toString().padStart(2, '0'),
      })
    },

    canSave() {
      return (
        this.editableGap?.expectation?.trim?.() &&
        this.editableGap?.reality?.trim?.() &&
        this.editableGap?.conclusion?.trim?.()
      )
    },
  },

  methods: {
    saveGap() {
      this.$emit('save', this.editableGap)
      this.isEditMode = false
    },

    cancelEdition() {
      this.editableGap = { ...this.gap }
      this.isEditMode = false
    },
  },
}
</script>
<style lang="scss" scoped>
.gap-selected {
  border-color: $color-blue;
}
</style>
